<div class="form-group">
  <div>
    <h2>OT Schedule Upload</h2>
  </div>
</div>




<div class="form-group">
  <div class="row space-margin">



    <div class="col-md-4">

      <app-search [filter]="filter" (search)="searchOTSchedule()"></app-search>


    </div>


    <div class="col-md-6">
      <button class="btn btn-success mr-3  float-right" type="button" data-toggle="modal" (click)="uploadCsrc()">
        <i class="fas fa-upload"></i> Upload
      </button>
      <!-- <button class="btn btn-danger mr-3 float-right" type="button" data-toggle="modal" (click)="onDelete()">
        <i class="fa fa-trash"></i> Delete All
      </button> -->
    </div>

  </div>
</div>

<div class="row">
  <div class="col-md-12" *ngIf="!otSchedule|| otSchedule.length == 0">
    No OT schedule upload data found
  </div>
</div>

<div class="row" *ngIf="otScheduleCount">
  <div class="col-md-3">
    <div style="color: #B5B4B4;">
      <h4 style="color:gray">Total:<span class="badge ng-binding" style="font-size: 20px;">{{otScheduleCount ||
          0}}</span>
      </h4>
      <div class="col-sm-2 pull-left"> </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-12 table-wrapper-scroll-y my-custom-scrollbar height:100px">
    <table class="table table-hover table-outline mb-0" style="background-color: white;" *ngIf="otScheduleCount">
      <thead class="thead-default" style=" background-color: #c2cfd6;">
        <tr>
          <th>Candidate User ID<app-required></app-required></th>
          <th>Candidate Exam ID<app-required></app-required></th>
          <th>Status<app-required></app-required></th>
          <th>Obtained Marks</th>
          <th>Total Marks</th>
          <th>Percentage</th>
          <th>Report Status<app-required></app-required></th>
        </tr>
      </thead>
      <tr *ngFor="let t of otSchedule;" style="cursor:pointer" (click)="OnClick(t._id)">
        <td>{{t.can_userid}}</td>
        <td>{{t.can_examid}}</td>
        <td>{{t.status}}</td>
        <td>{{t.obtained_marks}}</td>
        <td>{{t.total_marks}}</td>
        <td>{{t.percentage}}</td>
        <td>{{t.report_status}}</td>
      </tr>
    </table>
  </div>
</div>

<div class="row" *ngIf="otScheduleCount >= 25">
  <div class="col-md-12">

    <app-pagination [(currentPage)]="currentPage" [pageSize]="pageSize" [totalRecords]="otScheduleCount"
      (pageChanged)="fetchexamData($event)"></app-pagination>
  </div>
</div>


<app-alert [sender]="sender"></app-alert>